<template>
    <v-container fluid class="pa-2">
        <v-card class="rounded-xl elevation-3 overflow-hidden" max-width="1100">
            <v-toolbar flat color="white" class="px-2 border-bottom">
                <v-avatar color="primary lighten-5" size="45" class="mr-3">
                    <v-icon color="primary" size="28">grid_view</v-icon>
                </v-avatar>
                <v-toolbar-title class="font-weight-bold blue--text text--darken-4">
                    MANTENIMIENTO DE SECCIONES
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="grey lighten-3 pb-0">
                <v-form ref="refFormSearch" v-model="dSearchValid">
                    <v-row align="center">
                        <v-col cols="12" sm="4" md="3">
                            <v-select
                                v-model="dSeccionSearch.Periodo"
                                label="Periodo Académico"
                                :items="dPeriodos"
                                filled
                                rounded
                                dense
                                background-color="white"
                                prepend-inner-icon="calendar_month"
                                :rules="[v => !!v || 'Requerido']"
                                hide-details
                                class="elevation-1"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="5" md="6">
                            <v-autocomplete
                                v-model="dSeccionSearch.IdServicio"
                                label="Carrera Profesional"
                                :items="ssPriServiciosIngreso"
                                item-value="IdServicio"
                                item-text="Descripcion2"
                                filled
                                rounded
                                dense
                                background-color="white"
                                prepend-inner-icon="school"
                                :rules="[v => !!v || 'Requerido']"
                                hide-details
                                class="elevation-1"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="d-flex justify-center">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="fuModalOpen()" :disabled="dSeccionSearch.IdServicio==''">
                                <v-icon>add</v-icon> Agregar Sección
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-text class="pa-0">
                <v-toolbar v-if="dTable.items.length>0" color="#2980b9" dark>
                    <v-text-field
                        v-model="dTable.search"
                        prepend-icon="filter_alt"
                        label="Filtrar por ..."
                        single-line
                        hide-details
                        dark
                        clearable
                    ></v-text-field>
                </v-toolbar>
                <v-data-table
                    :headers="dTable.headers"
                    :items="dTable.items"
                    :search="dTable.search"
                    :loading="dTable.loading"
                    class="custom-table"
                    hide-default-footer
                    :items-per-page="-1"
                >
                    <template v-slot:loading>
                        <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
                    </template>
                    <template v-slot:no-data>
                        <div class="pa-10 d-flex flex-column align-center">
                            <v-icon size="64" color="grey lighten-2">signal_cellular_no_sim</v-icon>
                            <div class="text-h3 grey--text text--lighten-1 mt-2"><strong>No hay registros para mostrar.</strong></div>
                        </div>
                    </template>
                    <template v-slot:item="{ item, headers }">
                        <tr>
                            <td v-for="header in headers" :key="header.value">
                                <template v-if="header.value === 'expand-icon'">
                                    <v-badge color="blue-grey" :content="item.ingcronogramapagos.length" overlap>
                                        <v-icon @click.stop="toggleExpand(item)" title="Cronograma de Pagos">
                                            {{ item.expanded ? 'calendar_today' : 'calendar_month' }}
                                        </v-icon>
                                    </v-badge>
                                </template>
                                <template v-else-if="header.value === 'actions'">
                                    <v-menu bottom offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-title><v-btn @click="fuEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-btn @click="fuMatriculaAperturarCerrar(item.IdSeccion, item.nMatriculaCerrada)" :color="item.nMatriculaCerrada===1 ? 'success':'error'" block>
                                                    <v-icon>{{ item.nMatriculaCerrada===1 ? 'vpn_key':'lock' }}</v-icon> 
                                                    {{ item.nMatriculaCerrada===1 ? 'Abrir Matricula':'Cerrar Matricula' }}
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-btn @click="fuSeccionActivarCerrar(item.IdSeccion, item.Concluyo)" :color="item.Concluyo=='1' ? 'success':'error'" block>
                                                    <v-icon>{{ item.Concluyo=='1' ? 'vpn_key':'lock' }}</v-icon> 
                                                    {{ item.Concluyo=='1' ? 'Abrir Sección':'Cerrar Sección' }}
                                                </v-btn>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                                <template v-else-if="header.value === 'Curricula'">
                                    <v-chip v-if="item.Curricula == 'Sin Currícula'" class="ma-2" color="red" text-color="white">{{ item.Curricula }}</v-chip>
                                    <span v-else class="font-weight-bold grey--text text--darken-3" @click="fuCopy(item.IdItinerario)">
                                        {{ item.Curricula }}
                                    </span>
                                </template>
                                <template v-else-if="header.value === 'Nivel'">
                                    <span class="font-weight-bold grey--text text--darken-3" @click="fuCopy(item.IdSeccion)" :title="item.IdSeccion">
                                        {{ item.Nivel + item.Seccion }}
                                    </span>
                                    <v-icon :title="fuTurno(item.Turno)" small color="grey">{{ fuTurnoIcono(item.Turno) }}</v-icon>
                                    <v-icon v-if="item.especial" title="No visible" small color="purple" class="ml-1">visibility_off</v-icon>
                                </template>
                                <template v-else-if="header.value === 'HoraTurno'">
                                    <span class="font-weight-bold grey--text text--darken-3">
                                        {{ item.HoraTurno }}
                                    </span>
                                </template>
                                <template v-else-if="header.value === 'Fechas'">
                                    <div class="text-caption">
                                        <v-icon small color="grey" class="mr-1">calendar_month</v-icon>
                                        {{ item.Fechas }}
                                    </div>
                                </template>
                                <template v-else-if="header.value === 'nMatriculaCerrada'">
                                    <v-icon :color="dDiccionarioMatricula[item.nMatriculaCerrada][0]">{{dDiccionarioMatricula[item.nMatriculaCerrada][1]}}</v-icon>
                                    {{dDiccionarioMatricula[item.nMatriculaCerrada][2]}}
                                </template>
                                <template v-else-if="header.value === 'Concluyo'">
                                    <v-icon :color="dDiccionarioSeccion[item.Concluyo][0]">{{dDiccionarioSeccion[item.Concluyo][1]}}</v-icon>
                                    {{dDiccionarioSeccion[item.Concluyo][2]}}
                                </template>
                                
                            </td>
                        </tr>
                        <tr v-if="item.expanded">
                            <td :colspan="headers.length">
                                <div v-if="item.expanded">
                                    <v-card flat>
                                        <v-card-text>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr style="background: #5F89A7;">
                                                        <th style="width: 10%">...</th>
                                                        <th style="width: 15%">MES</th>
                                                        <th style="width: 15%">FECHA DE PAGO</th>
                                                        <th style="width: 20%" class="text-right">MONTO</th>
                                                        <th style="width: 40%">ESCALA</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item2 in item.ingcronogramapagos" :key="item2.IdMes" style="border-bottom:2pt solid black;">
                                                        <td style="width: 10%">
                                                            <div class="d-flex align-center">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn @click="fuEditCronogramaPago(item.IdSeccion, item2)" icon v-bind="attrs" v-on="on" class="mr-1">
                                                                            <v-icon>edit</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Editar</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn @click="fuDelete(item2)" icon v-bind="attrs" v-on="on">
                                                                            <v-icon>clear</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Eliminar</span>
                                                                </v-tooltip>
                                                            </div>
                                                        </td>
                                                        <td style="width: 15%">
                                                            <span :title="item2.IdCronograma">{{fuMesMensualidad(item2.IdMes)}}</span>
                                                        </td>
                                                        <td style="width: 15%">
                                                            <div class="text-caption">
                                                                <v-icon small color="grey" class="mr-1">calendar_month</v-icon>
                                                                {{ fuFormatDate(item2.FechaDeuda) }}
                                                            </div>
                                                        </td>
                                                        <td style="width: 20%" class="text-right">
                                                            <span>
                                                                S/. {{ item2.Monto != null && !isNaN(item2.Monto) ? Number(item2.Monto).toFixed(2) : '0.00' }}
                                                            </span>
                                                        </td>
                                                        <td style="width: 40%">
                                                            <span :title="item2.IdEscala">
                                                                {{ item2.ingescala.Descripcion }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan="5">
                                                            <v-btn @click="fuModalCronogramaOpen(item.IdSeccion)" block color="success">
                                                                <v-icon>add</v-icon> Agregar Cronograma
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </v-simple-table>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-navigation-drawer v-model="dModalMain.dialog" fixed right width="450" class="elevation-10">
            <div class="d-flex flex-column">
                <v-toolbar flat color="primary" dark>
                    <v-toolbar-title class="font-weight-bold">
                        {{ dMatSeccion.IdSeccion ? 'Editar' : 'Agregar' }} Sección
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dModalMain.dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="flex-grow-1 overflow-y-auto pa-3">
                    <v-form ref="refForm" v-model="dModalMain.valid" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <v-alert icon="school" prominent text type="info" dense>{{coServicioDescripcion}}</v-alert>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-alert text color="info">{{dSeccionSearch.Periodo}}</v-alert>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select
                                    :items="dMatPeriodos"
                                    v-model="dMatSeccion.IdPeriodo"
                                    item-value="IdPeriodo"
                                    item-text="Nivel"
                                    label="Nivel"
                                    filled
                                    dense
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select
                                    :items="dMatSeccionLetrasDisponibles"
                                    v-model="dMatSeccion.Seccion"
                                    label="Sección"
                                    filled
                                    dense
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select
                                    :items="['M', 'T', 'N', 'V']"
                                    v-model="dMatSeccion.Turno"
                                    label="Turno"
                                    filled
                                    dense
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-menu
                                    v-model="dFechaInicioMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFechaInicio"
                                            label="Fecha Inicio"
                                            prepend-inner-icon="event"
                                            readonly
                                            filled dense
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[v => !!v || 'Campo requerido']"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFechaInicio"
                                        @input="dFechaInicioMenu = false"
                                        no-title
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-menu
                                    v-model="dFechaFinMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFechaFin"
                                            label="Fecha Fin"
                                            prepend-inner-icon="event"
                                            readonly
                                            filled dense
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules="[v => !!v || 'Campo requerido']"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFechaFin"
                                        @input="dFechaFinMenu = false"
                                        no-title
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-select
                                    :items="['Presencial', 'SemiPresencial', 'Virtual']"
                                    v-model="dMatSeccion.Modalidad"
                                    label="Modalidad"
                                    filled
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="dMatSeccion.HoraTurno" label="Hora Turno" :maxlength="20" autocomplete="off" filled dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-switch v-model="dMatSeccion.especial" label="Ocultar en Matricula" inset dense class="ma-0"></v-switch>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-select
                                    :items="dDcbItinerario"
                                    v-model="dMatSeccion.IdItinerario"
                                    item-value="IdItinerario"
                                    item-text="Curricula"
                                    label="Itinerario"
                                    filled
                                    dense
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <div class="pa-4 bg-grey lighten-4">
                    <v-btn 
                        block
                        color="primary" 
                        size="large"
                        class="text-none rounded-lg py-6" 
                        elevation="2"
                        :loading="dModalMain.loading"
                        @click="fuSave"
                    >
                        <v-icon> save</v-icon> Guardar
                    </v-btn>
                </div>
            </div>
        </v-navigation-drawer>
        <v-dialog v-model="dModalCronogramaPago.dialog" max-width="500">
            <v-card>
                <v-form ref="refCronogramaPago">
                    <v-card-title class="text-h5 blue-grey">
                        <v-spacer></v-spacer>
                        <v-btn @click="fuSaveCronograma" color="default"><v-icon>save</v-icon> {{ dIngCronogramaPago.IdCronograma ? 'Editar' : 'Agregar' }} Cronograma</v-btn>
                        <v-btn @click="dModalCronogramaPago.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-2">
                        <v-container fluid class="pa-1">
                            <v-row>
                                <v-col cols="12" sm="12" class="pa-2">
                                    <v-select v-model="dIDConcepto" label="* Concepto" :items="dIngConceptos" item-value="IDConcepto" item-text="Concepto" filled dense prepend-inner-icon="account_balance" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" class="pa-2">
                                    <v-autocomplete v-model="dIngCronogramaPago.IdEscala" label="* Escala" :items="dIngEscalas" item-value="IDEscala" item-text="Descripcion" filled dense prepend-inner-icon="price_change" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" class="pa-2">
                                    <v-select v-model="dIngCronogramaPago.IdMes" :items="[
                                        {text: 'MATRICULA', value: 0},
                                        {text: 'ENERO', value: 1},
                                        {text: 'FEBRERO', value: 2},
                                        {text: 'MARZO', value: 3},
                                        {text: 'ABRIL', value: 4},
                                        {text: 'MAYO', value: 5},
                                        {text: 'JUNIO', value: 6},
                                        {text: 'JULIO', value: 7},
                                        {text: 'AGOSTO', value: 8},
                                        {text: 'SEPTIEMBRE', value: 9},
                                        {text: 'OCTUBRE', value: 10},
                                        {text: 'NOVIEMBRE', value: 11},
                                        {text: 'DICIEMBRE', value: 12},
                                    ]" label="* Mes" :rules="[v => (v !== null && v !== undefined && v !== '') || 'Campo requerido']"
                                    prepend-inner-icon="event_available" filled dense></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" class="pa-2">
                                    <v-menu
                                        v-model="dFechaDeudaMenu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="dFechaDeuda"
                                                label="* Fecha de pago"
                                                prepend-inner-icon="alarm"
                                                readonly
                                                filled dense
                                                v-bind="attrs"
                                                v-on="on"
                                                :rules="[v => !!v || 'Campo requerido']"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="dFechaDeuda"
                                            @input="dFechaDeudaMenu = false"
                                            no-title
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2';
import {fuFormatDate, fuTurno, fuTurnoIcono, fuCopy, fuMesMensualidad} from '@/helpers/index.js';

const transformData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    return data.flatMap(periodo => {
        const { IdPeriodo, Anio, Periodo, Nivel, priservicio, matseccions } = periodo;

        if (!matseccions) return [];

        const Respuesta = matseccions.map(seccion => ({
            IdSeccion: seccion.IdSeccion,
            Seccion: seccion.Seccion,
            FechaInicio: seccion.FechaInicio,
            FechaFin: seccion.FechaFin,
            Fechas: fuFormatDate(seccion.FechaInicio) + ' - ' + fuFormatDate(seccion.FechaFin),
            Turno: seccion.Turno,
            HoraTurno: seccion.HoraTurno,
            Concluyo: (seccion.Concluyo === null || seccion.Concluyo === undefined || seccion.Concluyo === '') ? '0' : String(seccion.Concluyo),
            nMatriculaCerrada: (seccion.nMatriculaCerrada === null || seccion.nMatriculaCerrada === undefined) ? 0 : Number(seccion.nMatriculaCerrada),
            Modalidad: seccion.Modalidad,
            especial: seccion.especial,
            IdItinerario: seccion.dcbitinerario?.IdItinerario || null,
            Curricula: seccion.dcbitinerario?.Curricula || 'Sin Currícula',
            IdPeriodo: IdPeriodo,
            Nivel: Nivel,
            NivelSeccion: Nivel + seccion.Seccion,
            ingcronogramapagos: seccion.ingcronogramapagos,
            expanded: false,
        }));

        return [...Respuesta].sort((a, b) => {
            const nivelA = Number(a.Nivel) || 0;
            const nivelB = Number(b.Nivel) || 0;

            if (nivelA !== nivelB) {
            return nivelA - nivelB;
            }

            const seccionA = a.Seccion ? String(a.Seccion).trim().toUpperCase() : '';
            const seccionB = b.Seccion ? String(b.Seccion).trim().toUpperCase() : '';

            return seccionA.localeCompare(seccionB, 'es', { sensitivity: 'base' });
        });
    });
};
const getInitialData = () => ({
    IdSeccion: null,
    IdPeriodo: null,
    Seccion: '',
    Turno: 'M',
    FechaInicio: '',
    FechaFin: '',
    Activa: '1',
    NroGrupos: 1,
    HoraTurno: '',
    Promedio:1,
    Modalidad: 'Presencial',
    especial: 0,
    IdUsuario: '',
    IdItinerario: null,
});
const QUERY_LOAD = gql`
    query ingconceptoByHabilitadoByMatricula($Habilitado: Boolean!, $Matricula: Boolean!) {
        ingconceptoByHabilitadoByMatricula(Habilitado: $Habilitado, Matricula: $Matricula) {
            IDConcepto
            Concepto
            ingescalas{
                IDEscala
                Descripcion
                Monto
                Habilitado
            }
        }
    }
`;
const ordenarConceptosYEscalas = (data) => {
  if (!data || !Array.isArray(data)) return [];

  return data
    .map(conceptoItem => {
      const escalasFiltradasYOrdenadas = conceptoItem.ingescalas
        ? [...conceptoItem.ingescalas]
            .filter(escala => escala.Habilitado === true || escala.Habilitado === 1 || escala.Habilitado === undefined)
            .sort((a, b) => {
              const descA = a.Descripcion || '';
              const descB = b.Descripcion || '';
              return descA.localeCompare(descB, 'es', { sensitivity: 'base' });
            })
        : [];

      return {
        ...conceptoItem,
        ingescalas: escalasFiltradasYOrdenadas
      };
    })
    .filter(conceptoItem => conceptoItem.ingescalas.length > 0)
    .sort((a, b) => {
      const conceptoA = a.Concepto || '';
      const conceptoB = b.Concepto || '';
      return conceptoA.localeCompare(conceptoB, 'es', { sensitivity: 'base' });
    });
};
const MUTATION_DELETE = gql`
    mutation ingcronogramapagoDelete($IdCronograma: ID!) {
        ingcronogramapagoDelete(IdCronograma: $IdCronograma) {
            IdCronograma
        }
    }
`;
export default {
    name: 'Seccion',
    mounted(){
        let today = new Date();
        for (var i = today.getFullYear()+1; i >= today.getFullYear()-20; i--) {
            this.dPeriodos.push(i+'-2');
            this.dPeriodos.push(i+'-1');
        }
        this.dSeccionSearch.Periodo = today.getFullYear()+'-'+(today.getMonth()<=6 ? '1' : '2');
        this.fuLoad();
        if(this.ssUser) {
            this.dMatSeccion.IdUsuario = this.ssUser.Usuario;
            this.dIngCronogramaPago.IdUsuario = this.ssUser.Usuario;
        }
    },
    data: () => ({
        dLoading : false,
        dSearchValid: false,
        dFechaInicio: '',
        dFechaFin: '',
        dFechaDeuda: '',
        dFechaInicioMenu: false,
        dFechaFinMenu: false,
        dFechaDeudaMenu: false,
        dPeriodos: [],
        dSeccionSearch: {
            IdServicio: '',
            Periodo: '',
        },
        dTable: {
            loading: false,
            headers: [
                { text: '...', value: 'actions', sortable: false, align: 'center' },
                { text: 'Itinerario', value: 'Curricula', align: 'start' },
                { text: 'Sección', value: 'Nivel', align: 'start' },
                { text: 'HoraTurno', value: 'HoraTurno', align: 'start' },
                { text: 'Fecha', value: 'Fechas', align: 'center' },
                { text: 'Estado Matricula', value: 'nMatriculaCerrada', width: '12%'},
                { text: 'Estado Sección', value: 'Concluyo', width: '12%'},
                { value: 'expand-icon', text: '', sortable: false, width: '1%'},
                { text: 'NivelSeccion', value: 'NivelSeccion', class: 'd-none'},
            ],
            items: [],
            search: null,
        },
        dTableCronograma: {
            loading: false,
            headers: [
                { text: '...', value: 'actions', sortable: false, align: 'start' },
                { text: 'Mes', value: 'IdMes', align: 'start' },
                { text: 'Fecha Deuda', value: 'FechaDeuda', align: 'center' },
                { text: 'Monto', value: 'Monto', align: 'end' },
                { text: 'Escala', value: 'ingescala.Descripcion', align: 'start' },
            ],
            items: [],
        },
        dDiccionarioMatricula: {
            0 : ['success','vpn_key', 'Abierta'],
            1 : ['error','lock', 'Cerrada'],
        },
        dDiccionarioSeccion: {
            0 : ['success','vpn_key', 'Abierta'],
            1 : ['error','lock', 'Cerrada'],
        },
        dModalMain: {
            dialog: false,
            loading: false,
            valid: true
        },
        dModalCronograma: {
            dialog: false,
            loading: false,
            valid: true
        },
        dModalCronogramaPago: {
            dialog: false,
            loading: false,
            valid: true
        },
        dMatSeccion: getInitialData(),
        dSeccion: "",
        dMatPeriodos: [],
        dMatSeccionLetrasDisponibles: [],
        dDcbItinerario: [],
        dIngConceptos: [],
        dIDConcepto: null,
        dIngEscalas: [],
        dIngCronogramaPago: {
            IdCronograma: null,
            IdSeccion: null,
            IdMes: null,
            FechaDeuda: '',
            IdEscala: null,
            Monto: 0,
            IdUsuario: '',
        }
    }),
    computed: {
        ...mapState(['ssUser','ssPriServiciosIngreso']),
        coServicioDescripcion() {
            const carrera = this.ssPriServiciosIngreso.find(
                item => item.IdServicio === this.dSeccionSearch.IdServicio
            );
            return carrera ? carrera.Descripcion2 : 'Ninguna carrera seleccionada';
        }
    },
    watch: {
        'dSeccionSearch.Periodo' (val) {
            this.dSeccionSearch.IdServicio = '';
            this.dTable.items = [];
        },
        'dSeccionSearch.IdServicio' (val) {
            if (val && val !== '') {
                this.fuSeccionSearch();
            }
        },
        'dMatSeccion.IdPeriodo' (val) {
            if (val && val !== '') {
                this.fuLetrasDisponibles(val);
            }
        },
        'dIngCronogramaPago.IdEscala' (val) {
            if (val && val !== '') {
                const vEscala = this.dIngEscalas.find(item => item.IDEscala == val);
                this.dIngCronogramaPago.Monto = vEscala.Monto;
            }
        },
        dFechaInicio(val) {
            if (val && val !== '') {
                this.dMatSeccion.FechaInicio = val.split("-").join("");
            }
        },
        dFechaFin(val) {
            if (val && val !== '') {
                this.dMatSeccion.FechaFin = val.split("-").join("");
            }
        },
        dFechaDeuda(val) {
            if (val && val !== '') {
                this.dIngCronogramaPago.FechaDeuda = val.split("-").join("");
            }
        },
        dIDConcepto(val){
            if (val && val !== '') {
                this.dIngCronogramaPago.IdEscala = null;
                this.dIngCronogramaPago.Monto = null;
                this.dIngEscalas = [];
                const vConcepto = this.dIngConceptos.find(item => item.IDConcepto === val);

                if(vConcepto.ingescalas){
                    this.dIngEscalas = vConcepto.ingescalas.map(item => ({
                        IDEscala: item.IDEscala,
                        Descripcion: 'S/. ' + (item.Monto != null && !isNaN(item.Monto) ? Number(item.Monto).toFixed(2) : '0.00') + ' - ' + item.Descripcion,
                        Monto: item.Monto,
                    }));
                }
            }
        }
    },
    methods: {
        fuFormatDate, fuTurno, fuTurnoIcono, fuCopy, fuMesMensualidad,
        toggleExpand(item) {
            this.$set(item, 'expanded', !item.expanded);
        },
        async fuLoad() {
            try {
                const { data } = await this.$apollo.query({
                    query: QUERY_LOAD,
                    variables: {
                        Habilitado: true,
                        Matricula: true,
                    },
                    fetchPolicy: 'no-cache'
                });
                const datosCrudos = data.ingconceptoByHabilitadoByMatricula;
                this.dIngConceptos = ordenarConceptosYEscalas(datosCrudos);
            } catch (error) {
                console.error("Error cargando datos laborales:", error);
            }
        },
        fuLetrasDisponibles(vIdPeriodo) {
            const abecedario = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'Ñ', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            this.dMatSeccionLetrasDisponibles = [...abecedario];

            if(!this.dMatSeccion.IdSeccion){
                const periodoSeleccionado = (this.dMatPeriodos || []).find(
                    item => Number(item.IdPeriodo) === Number(vIdPeriodo)
                );                

                if (periodoSeleccionado && Array.isArray(periodoSeleccionado.matseccions)) {                    
                    const seccionesUtilizadas = periodoSeleccionado.matseccions
                        .map(seccion => seccion.Seccion ? seccion.Seccion.trim().toUpperCase() : '')
                        .filter(Boolean);

                    const setSecciones = new Set(seccionesUtilizadas);
                    this.dMatSeccionLetrasDisponibles = abecedario.filter(letra => !setSecciones.has(letra));
                }
            }
        },
        async fuSeccionSearch() {
            if (!this.$refs.refFormSearch.validate()) return;
            
            this.dTable.loading = true;
            this.dTable.items = [];
            const vArray = this.dSeccionSearch.Periodo.split("-");
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdServicio: Int!, $Anio: Int!, $Periodo: Int!){
                            matperiodoByIdServicioByAnioByPeriodo(IdServicio:$IdServicio,Anio:$Anio,Periodo:$Periodo){
                                IdPeriodo
                                Nivel
                                matseccions{
                                    IdSeccion
                                    Seccion
                                    FechaInicio
                                    FechaFin
                                    Turno
                                    HoraTurno
                                    Concluyo
                                    nMatriculaCerrada
                                    Modalidad
                                    especial
                                    dcbitinerario{
                                        IdItinerario
                                        Curricula
                                    }
                                    ingcronogramapagos{
                                        IdCronograma
                                        IdMes
                                        FechaDeuda
                                        Monto
                                        IdEscala
                                        ingescala{
                                            Descripcion
                                        }
                                    }
                                }
                            }
                            dcbitinerarioByIdServicioByActivo(IdServicio:$IdServicio, Activo:1){
                                IdItinerario
                                Curricula
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdServicio: this.dSeccionSearch.IdServicio,
                        Anio: vArray[0],
                        Periodo: vArray[1],
                    }
                });
                const Respuesta = response.data.matperiodoByIdServicioByAnioByPeriodo;
                this.dDcbItinerario = response.data.dcbitinerarioByIdServicioByActivo;
                this.dMatPeriodos = [...Respuesta].sort((a, b) => a.Nivel - b.Nivel);

                console.log(this.dMatPeriodos);
                
                this.dTable.items = transformData(this.dMatPeriodos);
            } catch (error) {
                console.error(error);
            } finally {
                this.dTable.loading = false;
            }
        },
        fuModalOpen() {
            this.dMatSeccion = getInitialData();
            if (this.$refs.refForm) this.$refs.refForm.resetValidation();
            this.dModalMain.dialog = true;
        },
        fuModalCronogramaOpen(vIdSeccion) {
            if (this.$refs.refCronogramaPago) this.$refs.refCronogramaPago.resetValidation();
            this.dModalCronogramaPago.dialog = true;
            this.dIngCronogramaPago.IdSeccion = vIdSeccion;
        },
        async fuSave() {
            if (!this.$refs.refForm.validate()) return;
            
            this.dModalMain.loading = true;
            const isEdit = !!this.dMatSeccion.IdSeccion;

            const MUTATION = isEdit ? gql`
                mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!) {
                    matseccionUpdate(IdSeccion: $IdSeccion, input: $input) { IdSeccion }
                }
            ` : gql`
                mutation matseccionCreate($input: matseccionCreateInput!) {
                    matseccionCreate(input: $input) { IdSeccion }
                }
            `;

            try {
                const { IdSeccion, ...copiaSinIdSeccion} = this.dMatSeccion;

                const variables = isEdit 
                    ? { IdSeccion: String(this.dMatSeccion.IdSeccion), input: copiaSinIdSeccion }
                    : { input: copiaSinIdSeccion };

                const { data } = await this.$apollo.mutate({
                    mutation: MUTATION,
                    variables: variables
                });

                if (data) {
                    await this.fuSeccionSearch();
                    this.dModalMain.dialog = false;
                    Swal.fire('¡Éxito!', isEdit ? 'Registro actualizado.' : 'Registro guardado.', 'success');
                }
            } catch (error) {
                console.error(error);
                Swal.fire('Error', 'Registro incorreco.', 'error');
            } finally {
                this.dModalMain.loading = false;
            }
        },
        async fuSaveCronograma() {
            if (!this.$refs.refCronogramaPago.validate()) return;

            this.dModalCronogramaPago.loading = true;
            const isEdit = !!this.dIngCronogramaPago.IdCronograma;

            const MUTATION = isEdit ? gql`
                mutation ingcronogramapagoUpdate($IdCronograma: ID!, $input: ingcronogramapagoUpdateInput!) {
                    ingcronogramapagoUpdate(IdCronograma: $IdCronograma, input: $input) { IdCronograma }
                }
            ` : gql`
                mutation ingcronogramapagoCreate($input: ingcronogramapagoCreateInput!) {
                    ingcronogramapagoCreate(input: $input) { IdCronograma }
                }
            `;

            try {
                const { IdCronograma, ...copiaSinIdCronograma} = this.dIngCronogramaPago;

                const variables = isEdit 
                    ? { IdCronograma: String(this.dIngCronogramaPago.IdCronograma), input: copiaSinIdCronograma }
                    : { input: copiaSinIdCronograma };

                const { data } = await this.$apollo.mutate({
                    mutation: MUTATION,
                    variables: variables
                });

                if (data) {
                    Swal.fire('¡Éxito!', isEdit ? 'Registro actualizado.' : 'Registro guardado.', 'success');
                    this.dModalCronogramaPago.dialog = false;
                    this.fuSeccionSearch();
                }
            } catch (error) {
                console.error(error);
                Swal.fire('Error', 'Registro incorreco.', 'error');
            } finally {
                this.dModalMain.loading = false;
            }
        },
        fuEdit(item) {
            this.dMatSeccion.IdPeriodo = item.IdPeriodo;
            this.dMatSeccion.Turno = item.Turno;
            this.dFechaInicio = item.FechaInicio.substring(0, 10);
            this.dFechaFin = item.FechaFin.substring(0, 10);
            this.dMatSeccion.HoraTurno = item.HoraTurno;
            this.dMatSeccion.Modalidad = item.Modalidad;
            this.dMatSeccion.especial = item.especial;
            this.dMatSeccion.IdItinerario = item.IdItinerario;
            this.dMatSeccion.IdSeccion = item.IdSeccion;
            this.dMatSeccion.Seccion = item.Seccion;
            
            if (this.$refs.refForm) this.$refs.refForm.resetValidation();
            this.dModalMain.dialog = true;
        },
        fuEditCronogramaPago(vIdSeccion, vItem) {
            this.dIngCronogramaPago.IdCronograma = vItem.IdCronograma;
            this.dIngCronogramaPago.IdSeccion = vIdSeccion;
            this.dIngCronogramaPago.IdMes = vItem.IdMes;
            this.dFechaDeuda = vItem.FechaDeuda.substring(0, 10);
            this.dIDConcepto = this.fuIDConceptoByIdEscala(this.dIngConceptos, vItem.IdEscala);

            setTimeout(() => {
                this.dIngCronogramaPago.IdEscala = String(vItem.IdEscala);
            }, 500);

            this.dModalCronogramaPago.dialog = true;
        },
        fuIDConceptoByIdEscala(objetoData, IdEscalaBuscado) {
            const conceptoEncontrado = objetoData.find(concepto => 
                concepto.ingescalas.some(escala => escala.IDEscala == IdEscalaBuscado)
            );
            return conceptoEncontrado ? conceptoEncontrado.IDConcepto : null;
        },
        async fuDelete(item) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: `Se eliminará el registro. Esta acción no se puede deshacer.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            });

            if (result.value || result.isConfirmed) {         
                try {
                    await this.$apollo.mutate({
                        mutation: MUTATION_DELETE,
                        variables: { IdCronograma: String(item.IdCronograma) }
                    });
                    
                    this.fuSeccionSearch();
                    Swal.fire('Eliminado', 'El registro ha sido borrado con éxito.', 'success');
                } catch (error) {
                    console.error("Error al eliminar:", error);
                    Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                } finally {
               }
            }
        },
        fuMatriculaAperturarCerrar(vIdSeccion, vnMatriculaCerrada){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (vnMatriculaCerrada==1)
                        this.fuMatriculaAperturarCerrarUpdate(vIdSeccion, 0);
                    else
                        this.fuMatriculaAperturarCerrarUpdate(vIdSeccion, 1);
                },
            }).then((result) => {
            })
        },
        async fuMatriculaAperturarCerrarUpdate(vIdSeccion, vCerrado) {
            try {
                this.dLoading = true;
                var data = null;
                if(vCerrado==0){
                    data = {
                        nMatriculaCerrada: vCerrado
                    }
                } else {
                    data = {
                        nMatriculaCerrada: vCerrado,
                        dFechaCierre: moment().format("YYYYMMDD HH:mm:ss"),
                        cUsuarioCierreMatricula: this.ssUser.Usuario
                    }
                }

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!){
                        matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                            IdSeccion
                        }
                    }`,
                    variables: {
                        IdSeccion: vIdSeccion,
                        input: data
                    }
                });

                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.fuSeccionSearch();
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuSeccionActivarCerrar(vIdSeccion, vConcluyo){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: (login) => {
                    if (vConcluyo=='1')
                        this.fuSeccionActivarCerrarUpdate(vIdSeccion, 0);
                    else
                        this.fuSeccionActivarCerrarUpdate(vIdSeccion, 1);
                },
            }).then((result) => {
            })
        },
        async fuSeccionActivarCerrarUpdate(vIdSeccion, vConcluyo) {
            try {
                this.dLoading = true;
                var response = null;

                if(vConcluyo==0) {
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation matseccionUpdate($IdSeccion: ID!, $input: matseccionUpdateInput!){
                            matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                                IdSeccion
                            }
                        }`,
                        variables: {
                            IdSeccion: vIdSeccion,
                            input: {
                                Concluyo: vConcluyo
                            }
                        }
                    });
                } else {
                    response = await this.$apollo.mutate({
                        mutation: gql`mutation muSeccionCerrar($IdSeccion: ID!, $IdSeccion2: Int!, $Operador: String!, $input: matseccionUpdateInput!){
                            mutation1: dcbhorarioSPHORARIOS(IdSeccion: $IdSeccion2, Accion: "4"){
                                error
                            },
                            mutation2: dcbnotarecuperacionBySeccionInsertUpdate(IdSeccion: $IdSeccion2, Operador: $Operador, Accion: "C"){
                                error
                            },
                            mutation3: matseccionUpdate(IdSeccion: $IdSeccion, input: $input){
                                IdSeccion
                            }
                        }`,
                        variables: {
                            IdSeccion: vIdSeccion,
                            IdSeccion2: vIdSeccion,
                            Operador : this.ssUser.Usuario,
                            input: {
                                Concluyo: vConcluyo
                            },
                        }
                    });
                }
                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                    this.fuSeccionSearch();
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
<style scoped>
.custom-table >>> thead th {
  background-color: #2980b9 !important;
  color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em;
}
.custom-table >>> tbody tr:nth-of-type(even) {
  background-color: #f5f5f5; /* Un gris muy claro */
}
.custom-table >>> tbody tr:hover {
  background-color: #eeeeee !important;
  transition: background-color 0.2s ease;
}

.custom-table >>> td {
  border-bottom: 1px solid #f1f5f9 !important;
}
</style>
